import { Component, TemplateRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { SessionService } from 'src/app/services/session.service';
import { UserService } from 'src/app/services/user.service';
import { UiTranslationService } from 'src/app/services/ui-translation.service';

export const passwordMatchValidator: ValidatorFn = (formGroup: AbstractControl): ValidationErrors | null => {
  const oldPwd = formGroup.get('oldPwd');
  const newPwd = formGroup.get('newPwd');

  if (!oldPwd || !newPwd) {
    return null; // no se puede validar si no existen los controles
  }

  return oldPwd.value === newPwd.value ? null : { passwordMismatch: true };
};

@Component({
  selector: 'app-login-register',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.css']
})



export class LoginRegisterComponent {
  logIn: boolean = true;
  recoverPwd: boolean = false;
  emailFormat = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$';
  myFormRegister: any = FormGroup;
  myFormLogin: any = FormGroup;
  forgotPwdForm: any = FormGroup;
  @ViewChild('miModal', { static: true }) miModal: any = TemplateRef<any>;
  @ViewChild('modalCode', { static: true }) modalCode: any = TemplateRef<any>;
  verificationCode: string = "";
  private otpFlow: 'register' | 'recovery' | null = null;
  public loading = false;
  @Output() _showModal: any = new EventEmitter<string>();
  constructor(private toastr: ToastrService, public fb: FormBuilder, private userService: UserService, private modalService: NgbModal,
    private sessionService: SessionService, private i18n: UiTranslationService) {

    this.myFormRegister = this.fb.group({
      Name: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]],
      Email: ['', [Validators.required, this.customEmailValidator]],
      PhoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      Password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]],
    });

    this.myFormLogin = this.fb.group({
      Email: ['', [Validators.required, this.customEmailValidator]],
      Password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]],
    });

    this.forgotPwdForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(this.emailFormat)]],
      oldPwd: ['', [Validators.required, Validators.minLength(5)]],
      newPwd: ['', [Validators.required, Validators.minLength(5)]]
    }, { validator: passwordMatchValidator });
  }

  ngOnInit(): void {

    const userInformation = this.sessionService.getData('userInformation');
    const showModal = this.sessionService.getData('showModal') ? this.sessionService.getData('showModal') : true;
    
    
    if(userInformation === null && showModal === true){
      this.modalService.open(this.miModal, { centered: true });
    }
  }


  logInRegister(value: boolean, op: number){
    switch(op){
      case 1:
        this.logIn = value;
        this.recoverPwd = false;
        break;
      case 2:
        this.recoverPwd = this.recoverPwd ? false : true;
    }
  }

  setIsUser(){    
    // localStorage.setItem("isUser", "true");
    // let encondeEmail = btoa(this.email);
    // localStorage.setItem("isEmail", encondeEmail)
    // this.modalService.dismissAll(this.miModal)
    // this.email = "";
    this.toastr.success(this.i18n.translate('profile.saved'));
  }

  createUser(){
    this.loading = true;
    let objUser = {
      Nombre: this.myFormRegister.controls["Name"].value,
      Correo: btoa(this.myFormRegister.controls["Email"].value),
      Contrasena: btoa(this.myFormRegister.controls["Password"].value),
      Telefono: this.myFormRegister.controls["PhoneNumber"].value.toString(),
      TipoIdioma: "0",
      TipoMoneda: "0"
    };

    this.userService.setTemporalUser(objUser).subscribe({
      next: () => {
        this.loading = false;
        this.toastr.success(this.i18n.translate('auth.userCreated'));
        this.otpFlow = 'register';
        this.modalService.open(this.modalCode, { centered: true, backdrop: 'static', keyboard: false });
      },
      error: (error) => {
        this.loading = false;
        if (error.status === 401) {
          this.showRequestError();
        } else if (error.status !== 200) {
          this.showRequestError();
        }
      }
    });
  }

  customEmailValidator(control:any) {
    const value = control.value;
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    
    if (value && !regex.test(value)) {
      return { invalidEmail: true };
    }
    
    return null;
  }

  loginUser(){
    this.loading = true;
    let objUser = {
      email: btoa(this.myFormLogin.controls["Email"].value),
      password: btoa(this.myFormLogin .controls["Password"].value)
    };

    this.userService.loginTemporalUser(objUser).subscribe((response:any) => {
      this.loading = false;
      if(response.error){
        this.showRequestError();
      }else{
        this.toastr.success(this.i18n.translate('auth.welcome', { name: response.Response.name }));
        this.modalService.dismissAll(this.miModal);
        this.sessionService.setData('userInformation', JSON.stringify(response.Response));
        location.reload();
      }
    });
  }

  closeModal(){
    this.modalService.dismissAll(this.miModal);
    this.sessionService.setData('showModal', false);

  }

  onOtpChange(otp: any) {
    this.verificationCode = typeof otp === 'string' ? otp : '';
  }

  verifyCode(){
    if (this.loading) {
      return;
    }

    const otp = this.verificationCode.trim();
    const email = this.otpFlow === 'register'
      ? this.myFormRegister.controls["Email"].value
      : this.otpFlow === 'recovery'
        ? this.forgotPwdForm.controls["email"].value
        : null;

    if (!email || !otp) {
      this.toastr.error(this.i18n.translate('auth.invalidCode'), this.i18n.translate('common.error'));
      return;
    }

    const obj = {
      Correo: btoa(email),
      OTP: otp
    };

    this.loading = true;
    this.userService.updateVerificationCode(obj)
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: () => {
          this.modalService.dismissAll(this.modalCode);
          this.toastr.success(this.i18n.translate('auth.verified'));
          this.myFormRegister.reset();
          this.forgotPwdForm.reset();
          this.verificationCode = "";
          this.otpFlow = null;
          this.logIn = true;
          this.recoverPwd = false;
        },
        error: () => {
          this.toastr.error(this.i18n.translate('auth.invalidCode'), this.i18n.translate('common.error'));
        }
      });
  }

  showModal(){
    this.modalService.open(this.miModal, { centered: true });
  }

  recoveryPwd(){
    this.loading = true;
    let objUser = {
      Correo: btoa(this.forgotPwdForm.controls["email"].value),
      Contrasena: btoa(this.forgotPwdForm.controls["oldPwd"].value),
      RContrasena: btoa(this.forgotPwdForm.controls["newPwd"].value)
    };

    this.userService.recoveryPwd(objUser).subscribe({
      next: () => {
        this.loading = false;
        this.toastr.success('', this.i18n.translate('auth.codeSent'));
        this.otpFlow = 'recovery';
        this.modalService.open(this.modalCode, { centered: true, backdrop: 'static', keyboard: false });
      },
      error: (error) => {
        this.loading = false;
        if (error.status === 401) {
          this.showRequestError();
        } else if (error.status !== 200) {
          this.showRequestError();
        }
      }
    });
  }

  private showRequestError(): void {
    this.toastr.error(this.i18n.translate('messages.requestError'), this.i18n.translate('common.error'));
  }
}
